import { times } from 'lodash';
import { createSpeakingTaskType } from '../../createTaskType';
import SpeakingGenericEditor from '../../sharedLogic/SpeakingGenericEditor';
import { createSpeakingHighlightItem } from '../../sharedLogic/speakingItemCreators';
import withProps from "@dyl/utils/withProps";
import speakingConvertToUploadFormat from "@dyl/task-types/sharedLogic/speakingConvertToUploadFormat";

export default createSpeakingTaskType({
    id: 'scene_highlighting',
    label: 'What’s this',
    skill: 'speaking',
    v2: true,

    editor: withProps(SpeakingGenericEditor, { includeContextAudioField: true }),
    createItemsTemplate: () => times(4, createSpeakingHighlightItem),

    hasEndAudio: true,
    backgroundImages: {
        count: 1,
        configs: [{ helperText: 'Must be 1024x768px' }],
    },

    convertToUploadFormat: speakingConvertToUploadFormat,
});